import script from "./UserActivationsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UserActivationsTable.vue?vue&type=script&setup=true&lang=js"

import "./UserActivationsTable.vue?vue&type=style&index=0&id=6825e48b&scoped=true&lang=css"
script.__scopeId = "data-v-6825e48b"

export default script